export class InfiniteScrollAnchor {
    public Id: string;
    public OffsetTop: number;
}